module.exports = __webpack_public_path__ + "static/planted-vimy-oak-1-8c8e0c839c197874053992d7aafeb070.jpg";